/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Typography, Grid, Paper, Button } from "@material-ui/core";
import votBox from "../../assets/votBox.png";
import ActiveAuctionCard from "./Components/ActiveAuctionCard";
import UserIncentivesAccordion from "./Components/UserIncentivesAccordion";
import DepositForm from "./Components/DepositForm";
import Bribes from "./Components/Bribes";
import { RewardsOptimizationPrompt, UNION_ADDRESS } from "./Components/VoteCalculator";
import { useBribesData } from "./hooks/useBribesData";
import { useStylesDark, useStylesLight } from "../../Styles/AuctionPageStyles";
import { ethers } from "ethers";
import {
  addressRegistryAddress,
  addressRegistryABI,
  NETWORKS,
} from "../../constants";
import {
  getUserVote,
  votingPowerAtEpochOf,
  currentEpoch,
  getCurrentEpochDelegate,
  delegationStatus,
} from "../../scripts/scripts";

const readProviderFallback = new ethers.providers.JsonRpcProvider(
  NETWORKS.mainnet.rpcUrl
);

const AuctionPage = (props) => {
  const classesLight = useStylesLight();
  const classesDark = useStylesDark();
  var [classes, setClasses] = useState(classesDark);
  const [noActiveAuction, setNoActiveAuction] = useState(false);
  const [nextDate, setNextDate] = useState("Loading...");
  const [toggleText, setToggleText] = useState("Deposit a New Incentive");
  const [isAuctionOver, setIsAuctionOver] = useState(false);
  const [displayWarning, setDisplayWarning] = useState(false);
  const [vlCVXBalance, setVlCVXBalance] = useState(null); // null = not loaded
  const [userVote, setUserVote] = useState(null);
  const [voteIsFromDelegate, setVoteIsFromDelegate] = useState(false);
  const [forwardingAddress, setForwardingAddress] = useState(null);

  const handleAuctionOver = (isOver) => {
    setIsAuctionOver(isOver);
  };

  const market = props.market; // "fxn" | "yb" — undefined = default CVX market
  const { bribesArray, snapshotChoices, currentUser } = useBribesData(
    props.db,
    market,
    props.address,
    props.proposal,
    props.provider || readProviderFallback
  );
  let round = Math.floor(Math.floor(Date.now() / 1000) / (86400 * 14)) - 1348;
  if (market === "fxn") {
    round = round - 65;
  }
  if (market === "yb") {
    round = Math.floor(Math.floor(Date.now() / 1000) / (86400 * 7)) - 2910;
  }

  useEffect(() => {
    let currRound = round;
    if (market === "fxn") {
      currRound = currRound + 65;
    }
    if (market === "yb") {
      const weekIndex = Math.floor(Math.floor(Date.now() / 1000) / (86400 * 7));
      const weekStart = weekIndex * 86400 * 7;
      const deadlineTs = weekStart + 6 * 86400; // 24h before end
      if (Math.floor(Date.now() / 1000) > deadlineTs) {
        currRound = weekIndex + 1;
        setDisplayWarning(true);
      }
    } else {
      if (
        (currRound + 1348) * 86400 * 14 + 60 * 60 * 24 * 5 <
        Math.floor(Date.now() / 1000)
      ) {
        currRound++;
        setDisplayWarning(true);
      }
    }
  }, []);

  // check if there is an active round
  useEffect(() => {
    let currRound = round;
    if (market === "fxn") {
      currRound = currRound + 65;
    }
    if (market === "yb") {
      const weekIndex = Math.floor(Math.floor(Date.now() / 1000) / (86400 * 7));
      const weekStart = weekIndex * 86400 * 7;
      const deadlineTs = weekStart + 6 * 86400; // 24h before end
      if (Math.floor(Date.now() / 1000) > deadlineTs) {
        setNoActiveAuction(true);
      }
    } else {
      if (
        (currRound + 1348) * 86400 * 14 + 60 * 60 * 24 * 5 <
        Math.floor(Date.now() / 1000)
      ) {
        setNoActiveAuction(true);
      }
    }
  }, []);

  // theme setting
  useEffect(() => {
    if (props.ctheme === "light") {
      setClasses(classesLight);
    } else {
      setClasses(classesDark);
    }
  }, [props.ctheme]);

  // get next date
  useEffect(async () => {
    try {
      let setDate;
      if (market === "yb") {
        setDate =
          Math.floor(Math.floor(Date.now() / 1000) / (60 * 60 * 24 * 7)) *
            (60 * 60 * 24 * 7) +
          60 * 60 * 24 * 7;
      } else {
        setDate =
          Math.floor(Math.floor(Date.now() / 1000) / (60 * 60 * 24 * 14)) *
            (60 * 60 * 24 * 14) +
          60 * 60 * 24 * 14;
      }
      setDate = new Date(setDate * 1000);
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var month = months[setDate.getMonth()];
      var date = setDate.getDate();
      var j = Number(date) % 10;
      var k = Number(date) % 100;
      if (j == 1 && k != 11) {
        var ndate = date + "st";
      } else if (j == 2 && k != 12) {
        var ndate = date + "nd";
      } else if (j == 3 && k != 13) {
        var ndate = date + "rd";
      } else {
        var ndate = date + "th";
      }
      var hour =
        setDate.getHours() > 12
          ? setDate.getHours() - 12 + " PM"
          : setDate.getHours() + " AM";
      var zone = setDate
        .toLocaleDateString(undefined, {
          day: "2-digit",
          timeZoneName: "short",
        })
        .substring(4);
      var time = month + " " + ndate + ", " + hour + " " + zone;
      setNextDate(time);
    } catch {
      console.log("Couldn't figure out date");
    }
  }, []);

  const handleToggleClick = () => {
    if (toggleText === "Deposit a New Incentive") {
      setToggleText("Show All Incentives");
    } else {
      setToggleText("Deposit a New Incentive");
    }
  };

  useEffect(() => {
    if (toggleText === "Show All Incentives") {
      setToggleText("Deposit a New Incentive");
    }
  }, [market]);

  // Fetch voting power at proposal epoch (own lock and/or inbound gauge
  // delegation weight — pure delegate addresses often have 0 locked CVX).
  useEffect(() => {
    if (!props.address) {
      setVlCVXBalance(null);
      return;
    }
    const rpc = props.provider || readProviderFallback;
    const fetch = async () => {
      try {
        const epoch =
          props.proposal?.epoch != null
            ? props.proposal.epoch
            : currentEpoch();
        const bal = await votingPowerAtEpochOf(epoch, props.address, rpc);
        setVlCVXBalance(bal);
      } catch (e) {
        console.log("Couldn't fetch voting power", e);
        setVlCVXBalance(0);
      }
    };
    fetch();
  }, [props.address, props.proposal, props.provider]);

  // Fetch user's on-chain vote; fall back to current-epoch delegate's vote
  useEffect(() => {
    if (!props.proposal || !props.address) {
      setUserVote(null);
      setVoteIsFromDelegate(false);
      return;
    }
    const rpc = props.provider || readProviderFallback;
    const fetch = async () => {
      const platform = props.proposal.platform;
      const proposalId = props.proposal.id;
      const vote = await getUserVote(
        platform,
        proposalId,
        props.address,
        rpc
      );
      if (vote) {
        setUserVote(vote);
        setVoteIsFromDelegate(false);
        return;
      }
      // Only current-epoch delegate can vote this round; pending (next-epoch)
      // setup must not be treated as an active vote fallback.
      const currentDelegate = await getCurrentEpochDelegate(props.address, rpc);
      if (currentDelegate) {
        const delegateVote = await getUserVote(
          platform,
          proposalId,
          currentDelegate,
          rpc
        );
        if (delegateVote) {
          setUserVote(delegateVote);
          setVoteIsFromDelegate(true);
          return;
        }
      }
      setUserVote(null);
      setVoteIsFromDelegate(false);
    };
    fetch();
  }, [props.proposal, props.address, props.delegateAddress, props.provider]);

  // Fetch forwarding address from registry
  useEffect(() => {
    if (!props.provider || !props.address) {
      setForwardingAddress(null);
      return;
    }
    const fetch = async () => {
      try {
        const contract = new ethers.Contract(
          addressRegistryAddress,
          addressRegistryABI,
          props.provider
        );
        const res = await contract.registry(props.address);
        if (
          res.start.toNumber() !== 0 &&
          res.expiration.toNumber() > Math.floor(Date.now() / 1000)
        ) {
          setForwardingAddress(res.to);
        } else {
          setForwardingAddress(null);
        }
      } catch (e) {
        console.log("Couldn't fetch forwarding address", e);
        setForwardingAddress(null);
      }
    };
    fetch();
  }, [props.provider, props.address]);

  const { isVotiumFull, isVotiumFuture } = delegationStatus(props.delegateAddress);
  const isDelegatedToVotium = isVotiumFull;
  const isForwardedToUnion =
    forwardingAddress &&
    forwardingAddress.toLowerCase() === UNION_ADDRESS.toLowerCase();
  const isFullyRewardsOptimized = isDelegatedToVotium && isForwardedToUnion;

  return (
    <>
      <Grid container direction="row" className={classes.auctionsContainer}>
        <>
          <Grid
            container
            direction="column"
            justifyContent="center"
            className={classes.activeContainer}
          >
            <>
              {!noActiveAuction ? (
                <>
                  <ActiveAuctionCard
                    ctheme={props.ctheme}
                    onAuctionCompletion={handleAuctionOver}
                    market={market}
                    bribesArray={bribesArray}
                    snapshotChoices={snapshotChoices}
                    proposal={props.proposal}
                    vlCVXBalance={vlCVXBalance}
                    userVote={userVote}
                    voteIsFromDelegate={voteIsFromDelegate}
                    forwardingAddress={forwardingAddress}
                    delegateAddress={props.delegateAddress}
                    refreshDelegation={props.refreshDelegation}
                    provider={props.provider}
                    address={props.address}
                    connect={props.connect}
                  />
                </>
              ) : (
                <>
                  <Paper className={classes.noActiveAuctionCard}>
                    <Typography
                      variant="h2"
                      className={classes.noActiveAuctionTitle}
                    >
                      There is currently no active gauge proposal vote{" "}
                    </Typography>
                    <Typography
                      variant="h3"
                      component="div"
                      className={classes.noActiveAuctionText}
                    >
                      <p>Next vote starts @ {nextDate}</p>
                      <p>
                        To be eligible for rewards, you must lock your CVX
                        before the date shown above.
                      </p>
                      {!isVotiumFuture && (
                        <p>
                          If delegating to Votium, you must delegate your locked
                          CVX before this date as well.
                        </p>
                      )}
                      {market !== "yb" && isFullyRewardsOptimized && (
                        <>
                          <p>
                            You're set up for automated voting and reward
                            conversion.
                          </p>
                        </>
                      )}
                    </Typography>
                    {market !== "yb" && !isFullyRewardsOptimized && (
                      <Grid item align="center">
                        <RewardsOptimizationPrompt
                          ctheme={props.ctheme}
                          delegateAddress={props.delegateAddress}
                          forwardingAddress={forwardingAddress}
                          provider={props.provider}
                          address={props.address}
                          refreshDelegation={props.refreshDelegation}
                          connect={props.connect}
                        />
                      </Grid>
                    )}
                    <Grid item align="center">
                      <Button
                        className={classes.faqButton}
                        onClick={() => {
                          window.open("https://docs.votium.app/faq/vlcvx-faq");
                        }}
                        variant="outlined"
                      >
                        Frequently Asked Questions
                      </Button>
                    </Grid>

                    <Grid container direction="row" justifyContent="center">
                      <Grid item>
                        <img
                          src={votBox}
                          alt="time-icon"
                          className={classes.votBox}
                        ></img>
                      </Grid>
                    </Grid>
                  </Paper>
                </>
              )}
              <UserIncentivesAccordion
                provider={props.provider}
                db={props.db}
                address={props.address}
                ctheme={props.ctheme}
              />

              <Paper className={classes.togglePaper}>
                <Button
                  classes={{
                    root: classes.toggleButton,
                    disabled: classes.toggleButtonDisabled,
                  }}
                  onClick={handleToggleClick}
                >
                  {toggleText}
                </Button>
              </Paper>

              {toggleText === "Deposit a New Incentive" ? (
                <Bribes
                  ctheme={props.ctheme}
                  market={market}
                  bribesArray={bribesArray}
                  currentUser={currentUser}
                />
              ) : (
                <>
                  {(isAuctionOver === true || displayWarning === true) && (
                    <Typography className={classes.auctionOverText}>
                      The depositing period for round {round} has ended. You can
                      now start depositing for round {round + 1}.
                    </Typography>
                  )}{" "}
                  <DepositForm
                    provider={props.provider}
                    address={props.address}
                    db={props.db}
                    displayForm={true}
                    ctheme={props.ctheme}
                  />
                </>
              )}
            </>
          </Grid>
        </>
      </Grid>
    </>
  );
};

export default AuctionPage;
